/* unplugin-vue-components disabled */import script from "./user.vue?vue&type=script&setup=true&lang=ts"
export * from "./user.vue?vue&type=script&setup=true&lang=ts"

import "./user.vue?vue&type=style&index=0&id=19688106&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/.pnpm/vue-loader@16.8.3_2s7cwfl64decoaat2pz2tykl6i/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19688106"]])

export default __exports__